export const GET_ALL_USERS = 'GET_ALL_USERS'
export const GET_SINGLE_USER = 'GET_SINGLE_USER'
export const GET_DASHBOARD_USER = 'GET_DASHBOARD_USER'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_ALL_BIDDING_USERS = 'GET_ALL_BIDDING_USERS'
